import { TypeSafeTemplateDelegate } from '../../../Utility/Handlebars/types';
import announcementContainerCompiled from './announcement-container.hbs';
import './announcement.scss';

export { contentTemplate, contentBodyTemplate } from './content';
export { defaultTemplate } from './default';
export { insufficientPlaylistRightsTemplate, videoNotSupportedTemplate } from './error';
export {
    socialMediaTemplate,
    facebookATemplate,
    facebookBTemplate,
    facebookCTemplate,
    instagramATemplate,
    instagramBTemplate,
    twitterATemplate,
    twitterBTemplate,
} from './socialmedia';
export { videoTemplate } from './video';

export const announcementContainerTemplate: TypeSafeTemplateDelegate<null> =
    announcementContainerCompiled;
